<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col cols="12" xl="12">
          <v-card
            elevation="0"
            class="all-trade-tab rounded-0 pt-3 px-0"
            :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'"
          >
            <v-tabs
              :background-color="
                $vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-5'
              "
              class="pa-0"
            >
              <v-tab
                v-for="(category, index) in bannerCategories"
                :key="index"
                @click="handleTabClick(category)"
              >
                {{ category.category_name }} Banner
              </v-tab>
              <v-tab-item
                v-for="(category, index) in bannerCategories"
                :key="index"
              >
                <v-card flat>
                  <component
                    :is="getBannerComponent(category.category_name)"
                  ></component>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import AnimatedBanner from "@/components/Marketing/AnimatedBanner.vue";
import Html5Banner from "@/components/Marketing/Html5Banner.vue";
import StaticBanner from "@/components/Marketing/StaticBanner.vue";
import { mapActions, mapState } from "vuex";
import { MARKETTINGTOOLS__ACTIONS } from "@/store/action-types";

export default {
  components: {
    StaticBanner,
    AnimatedBanner,
    Html5Banner,
  },
  data() {
    return {
      panel: [0],
    };
  },
  computed: {
    ...mapState("markettingtools", ["bannerCategories"]),
  },
  methods: {
    ...mapActions("markettingtools", [
      MARKETTINGTOOLS__ACTIONS.BANNERCATEGORIES,
    ]),
    getBannerComponent(categoryName) {
      switch (categoryName) {
        case "Static":
          return "StaticBanner";
        case "Animated":
          return "AnimatedBanner";
        case "HTML 5":
          return "Html5Banner";
        default:
          return "StaticBanner";
      }
    },
    handleTabClick(category = null) {
      let categoryName = "";
      if (category) {
        categoryName = category.category_name.toLowerCase() || null;
        // .replace(/[^\w\s]/gi, "")
        // .replace(/\s+/g, "-");
      }
      this.$router.push({
        path: "/marketing-tools",
        query: { "banner-type": categoryName },
      });
    },
  },
  mounted() {
    this[MARKETTINGTOOLS__ACTIONS.BANNERCATEGORIES]();
    this.$router.push({
      path: "/marketing-tools",
      query: { "banner-type": "static" },
    });
  },
};
</script>
